import 'element-closest';
import 'nodelist-foreach-polyfill';
import initModules from '../initModules';

const TABLE_TYPE_A = 'A';
const TABLE_CLASS = 'table';
const LABEL_CLASS = 'label';

class Tables {
  constructor(options = {}) {
    this.$element = options.element;
    this.tableLabelElements = [];
    this.tableHeaderElements = [];
  }

  init() {
    this.prepareMarkup();
    this.handleTableType();
  }

  prepareMarkup() {
    initModules({
      rootElement: this.$element,
      useSubModule: true,
    });
  }

  handleTableType() {
    // get label cells
    const $tdLabels = this.$element.querySelectorAll('td');

    $tdLabels.forEach((labelCell) => {
      this.tableLabelElements.push(labelCell);
    });

    // apply basic table styles
    this.$element.classList.add(TABLE_CLASS);

    // get table type (more to be added)
    const tableType = TABLE_TYPE_A;

    // add more with table module & special tables
    switch (tableType) {
      case TABLE_TYPE_A:
        this.handleTableTypeA(TABLE_TYPE_A);
        break;

      default:
        break;
    }
  }

  // handle RichText Tables
  handleTableTypeA() {
    // remove unnecassary attributes
    [...this.$element.attributes].forEach((attr) => {
      this.$element.removeAttribute(attr.name);
    });

    // remove captions
    const captions = this.$element.getElementsByTagName('caption');
    const captionsArray = [...captions];
    captionsArray.forEach((el, index) => {
      el.parentNode.removeChild(captionsArray[index]);
    });

    // set label cells
    const $tdLabels = this.$element.querySelectorAll('tr > td:first-child');
    $tdLabels.forEach((labelCell) => {

      labelCell.classList.add(LABEL_CLASS);
      this.tableLabelElements.push(labelCell);
    });

    // get all cells of table head
    const $thCells = this.$element.querySelectorAll('thead th');
    const hasHeader = ($thCells.length > 0);
    const $tbRows = this.$element.querySelectorAll('tbody tr');

    $tbRows.forEach((tableRow) => {
      const belongingTableCells = tableRow.querySelectorAll('td, th');
      const cellInfo = [];
      belongingTableCells.forEach((cell, index) => {
        const tableHeadText = hasHeader ? $thCells[index].innerText || $thCells[index].textContent : '';
        cellInfo.push({
          cell,
          tableHeadText,
        });
      });

      this.tableHeaderElements.push(
        {
          tableRow,
          cellInfo,
        },
      );
    });

    this.buildMobileHTML(hasHeader);
  }

  // build table HTML structure for mobile view
  buildMobileHTML(hasHeader) {
    let htmlContent = [];
    const mobileTableList = this.tableHeaderElements;
    const wrapper = document.createElement('section');
    this.$element.parentNode.insertBefore(wrapper, this.$element);
    wrapper.appendChild(this.$element);

    mobileTableList.forEach((tableRow) => {
      htmlContent = [];
      htmlContent.push(`<div class="table--mobile ${hasHeader ? '' : 'no-header'}"><table>`);

      // add body
      htmlContent.push('<tbody>');

      // add content cells
      tableRow.cellInfo.forEach((cell) => {
        if (hasHeader) {
          htmlContent.push('<tr>');
          htmlContent.push(`<th colspan="2">${cell.tableHeadText}</th>`);
          htmlContent.push('</tr>');
        }
        htmlContent.push(`<tr>${cell.cell.outerHTML}</tr>`);
      });

      htmlContent.push('</tbody></table></div>');

      wrapper.insertAdjacentHTML('beforeend', htmlContent.join(''));
    });
  }
}

export default Tables;
